<template>
  <div class="uk-background-gradient-primary uk-light">
    <div class="uk-container uk-container-expand">
      <nav class="uk-navbar-container uk-navbar-transparent" uk-navbar>
        <div class="uk-navbar-left">
          <ul class="uk-navbar-nav">
            <li><router-link to="/">Home</router-link></li>
            <li><router-link to="/reports">Reportes</router-link></li>
          </ul>
        </div>
        <div class="uk-navbar-right">
          <ul class="uk-navbar-nav uk-flex uk-flex-middle">
            <li>
              <router-link to="/profile">Hola {{ name }}</router-link>
              <div uk-dropdown>
                <ul class="uk-nav uk-dropdown-nav">
                  <li>
                    <a
                      @click="logout"
                    >
                      Logout
                    </a>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
import { ref, onBeforeMount } from 'vue';
import { getAuth, signOut, onAuthStateChanged } from "firebase/auth";
import { useRouter, useRoute } from "vue-router";

export default {
    setup() {
        const router = useRouter();
        const route = useRoute();
        const auth = getAuth();
        const name = ref('');

        onAuthStateChanged(auth, (user) => {
            if (user) {
              name.value = user.displayName;
            }
        });

        const logout = () => {
            // auth.signOut();
            // router.replace("/login");
            // name.value = '';
            signOut(auth).then(() => {
              // Sign-out successful.
              console.log('sign out successful');
              router.replace("/login");
              name.value = ref('');
            }).catch((error) => {
              // An error happened.
            });
        };

        return {    
            name,
            logout,
        };
    },
};
</script>

<style></style>
